/**
 * @generated SignedSource<<0d0a734e0fa0d34e467050db3aed24de>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceAsideFragment$data = {
  readonly createdAt: DateTime;
  readonly id: string;
  readonly license: string | null | undefined;
  readonly shortDescription: string | null | undefined;
  readonly versions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly clonedFrom: {
          readonly id: string;
          readonly version: Semver;
          readonly workspace: {
            readonly id: string;
            readonly slug: string;
          };
        } | null | undefined;
        readonly createdAt: DateTime;
        readonly entity: {
          readonly username: string;
          readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
        };
        readonly fromCompetition: {
          readonly events: {
            readonly nodes: ReadonlyArray<{
              readonly event: {
                readonly slug: string;
              };
            }>;
          };
          readonly id: string;
          readonly slug: string;
          readonly title: string;
        } | null | undefined;
        readonly id: string;
        readonly publishedAt: DateTime | null | undefined;
        readonly version: Semver;
        readonly " $fragmentSpreads": FragmentRefs<"WorkspaceVersionCardActionsFragment">;
      };
    }>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"TagListFragment" | "WorkspaceMetadataEditButtonFragment" | "WorkspaceVersionHistoryFragment">;
  readonly " $fragmentType": "WorkspaceAsideFragment";
};
export type WorkspaceAsideFragment$key = {
  readonly " $data"?: WorkspaceAsideFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceAsideFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "versions"
        ]
      }
    ]
  },
  "name": "WorkspaceAsideFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "license",
      "storageKey": null
    },
    (v1/*:: as any*/),
    {
      "alias": "versions",
      "args": null,
      "concreteType": "WorkspaceVersionConnection",
      "kind": "LinkedField",
      "name": "__WorkspaceAsideFragment_versions_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WorkspaceVersionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WorkspaceVersion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "entity",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "username",
                      "storageKey": null
                    },
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "thumbnail",
                          "value": true
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "EntityProfilePicFragment"
                    }
                  ],
                  "storageKey": null
                },
                (v1/*:: as any*/),
                (v2/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "publishedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "WorkspaceVersion",
                  "kind": "LinkedField",
                  "name": "clonedFrom",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/),
                    (v2/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Workspace",
                      "kind": "LinkedField",
                      "name": "workspace",
                      "plural": false,
                      "selections": [
                        (v0/*:: as any*/),
                        (v3/*:: as any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Competition",
                  "kind": "LinkedField",
                  "name": "fromCompetition",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    (v3/*:: as any*/),
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "first",
                          "value": 1
                        }
                      ],
                      "concreteType": "EventCompetitionConnection",
                      "kind": "LinkedField",
                      "name": "events",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "EventCompetition",
                          "kind": "LinkedField",
                          "name": "nodes",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Event",
                              "kind": "LinkedField",
                              "name": "event",
                              "plural": false,
                              "selections": [
                                (v3/*:: as any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "events(first:1)"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WorkspaceVersionCardActionsFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TagListFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceMetadataEditButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceVersionHistoryFragment"
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};
})();

(node as any).hash = "6c7af0f848290bc384f8fe2cc20023f7";

export default node;
